<template>
    <Teleport to="body">
        <div :class="['modal', show ? 'is-active' : '']">
            <div class="modal-background" @click.self="close"></div>
            <div class="modal-content is-huge" ref="modalContent">
                <slot name="body"></slot>
            </div>
            <button @click="close" class="modal-close is-large" aria-label="close"></button>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import { nextTick, ref } from "vue";
    import { useModalStack } from "./useModalStack";

    const emit = defineEmits<{
        closed: [];
    }>();

    const show = ref(false);
    const modalContent = ref<HTMLElement | null>(null);

    const { pushOpen, popClose } = useModalStack(close);

    function open() {
        pushOpen();
        show.value = true;

        nextTick(() => {
            if (modalContent.value) {
                modalContent.value.scrollTop = 0;
                modalContent.value.scrollLeft = 0;
            }
        });
    }

    function close() {
        if (!popClose()) {
            return;
        }

        show.value = false;
        emit("closed");
    }

    defineExpose({ open, close });
</script>

<style scoped>
    .modal {
        z-index: 1100;
    }
</style>
